export default __webpack_public_path__ + "locales/uk-UA/InviteDialog.json?hash=9edbca26299d139113fcc94c739301bc";